module.exports = __webpack_public_path__ + "front/img/bg05.0afcaeb2.png";